import { Component, OnInit, NgZone, ViewChild, Inject } from '@angular/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sp-feedback-reason-dialog',
  templateUrl: './feedback-reason-dialog.component.html',
  styleUrls: ['./feedback-reason-dialog.component.scss']
})
export class FeedbackReasonDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<FeedbackReasonDialogComponent>) { }

  public reason1: boolean;
  public reason2: boolean;
  public reason3: boolean;
  public reason4: boolean;
  public reason5: boolean;

  // @ViewChild('autosize') autosize: CdkTextareaAutosize;

  ngOnInit(): void {
  }

  // triggerResize() {
  //   // Wait for changes to be applied, then trigger textarea resize.
  //   this._ngZone.onStable.pipe(take(1))
  //       .subscribe(() => this.autosize.resizeToFitContent(true));
  // }

  closeFeedbackDialog() {
    this.dialogRef.close();
  }

}
